module.exports = __webpack_public_path__ + "img/apps.7248dc7b.png";